import {
  getMonitorList, handleMonitorList, getGroupList, handleGroupList, getSpecialConfig, getMaintianConfigList, handMaintianConfigList
} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";  // 导入封装后的axios请求

const state = {};

const getters = {};

const actions = {
  async getMonitorListMethod ({commit}, params) {
    return getMonitorList(getUrl(params)).then(response => response)
  },
  async requestMonitorListMethod ({commit}, params) {
    return handleMonitorList(params).then(response => response)
  },

  async getGroupConfigListMethod ({commit},params){
    return getGroupList(getUrl(params)).then(response => response)
  },

  async requestGroupConfigListMethod ({commit},params){
    return handleGroupList(params).then(response => response)
  },

  async getSpecialListMethod ({commit}, params ) {

    return getSpecialConfig(getUrl(params)).then(response => response)
  },


  async getMaintianListMethod ({commit}, params ) {

    return getMaintianConfigList(getUrl(params)).then(response => response)
  },

  async requestMaintianListMethod ({commit}, params) {
    return handMaintianConfigList(params).then(response => response)
  },





  // async getAllUserInfo ({commit}, params) {
  //   return getAllUserInfo(getUrl(params)).then(response => response)
  // }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/monitor/monitor.js